import React from "react";

import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import Spinner from "../../components/Reusable/Spinner";
import EditIcon from "../../Icons/EditIcon";
import CreateIcon from "../../Icons/CreateIcon";
import usePatchHook from "../../customHooks/usePatchHook";
const EditNoticeComponent = loadable(
  () => import("../../components/Notices/EditNotice")
);
const EditNotice = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetHook({
    url: `${APIS.NOTICE}${id}/`,
    queryKey: [`notice-${id}`],
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`notice-${id}`],
  });
  const handleEdit = async (values: any, setError: any) => {
    let formData = {
      ...values,
      branch: values?.branch?.map((item: any) => item.value),
      user: values?.user?.map((item: any) => item.value),
      staff: values?.staff?.map((item: any) => item.value),
    };
    console.log(formData);
    const url = `${APIS.NOTICE}${id}/`;
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Notice
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditNoticeComponent
          NoticeData={data}
          handleEdit={handleEdit}
          isPatchLoading={isPatchLoading}
        />
      )}
    </>
  );
};

export default EditNotice;
